import TermosDetails from "./ComponentsTermos/TermosDetails";
import Info from "../../components/Info/Info";
import Footer from "../../components/Footer/Footer";

export default function Termos(){
    return(
        <div>
            <TermosDetails/>
            <Info/>
            <Footer/>
        </div>
    )
}